import axios from 'axios';
import qs from 'qs';
class Http {
    constructor(baseURL) {
        if (typeof baseURL === 'undefined') {
          this.instance = axios.create({
            baseURL: window.host, // 设置默认的baseURL
          });
        } else {
          this.instance = axios.create({
            baseURL: baseURL, // 使用传入的baseURL
          });
        }
      }
  post(url, data) {
    return this.instance.post(url, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
  postfile(url,data){
    return this.instance.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  put(url, data) {
    return this.instance.put(url, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  get(url, params) {
    return this.instance.get(url, {params})
  }
  delete(url, params) {
    return this.instance.delete(url, qs.stringify(params), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
export default Http;